import { com } from '@eidu/web'
import PermittedActions = com.eidu.entity.permission.PermittedActions
import serializeToJsonString = com.eidu.entity.util.serializeToJsonString
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'

export type GetPermittedActionsParameters = {
  requested: PermittedActions
}

const getPermittedActions = async ({ requested }: GetPermittedActionsParameters): Promise<PermittedActions> => {
  return fetchAuthorized(
    (authContext) => {
      const effectiveUserId = authContext.impersonatedUserId ?? authContext.userEntityId
      return `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/user/${effectiveUserId}/get-permitted-actions`
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(requested),
      method: 'POST',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from getUserPermissions endpoint`)
    return PermittedActions.fromJsonString(await response.text())
  })
}

export default getPermittedActions
